/* MGC: no character limits on any customizer text field (2026-11-02). Color hex inputs are left as-is. */
(function(){
  function isHex(el){var a=(el.getAttribute('aria-label')||'')+' '+(el.placeholder||'');return /colou?r|#[0-9a-f]{6}/i.test(a);}
  function strip(root){
    if(!root||!root.querySelectorAll)return;
    var els=root.matches&&root.matches('input[maxlength],textarea[maxlength]')?[root]:[];
    els=els.concat([].slice.call(root.querySelectorAll('input[maxlength],textarea[maxlength]')));
    els.forEach(function(el){if(!el.closest('.mgc-eta-b')&&!isHex(el)&&!/^(email|tel|password|number)$/i.test(el.type))el.removeAttribute('maxlength');});
  }
  function start(){
    strip(document.body);
    new MutationObserver(function(ms){ms.forEach(function(m){
      if(m.type==='attributes'){strip(m.target);}else{m.addedNodes.forEach(function(n){if(n.nodeType===1)strip(n);});}
    });}).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['maxlength']});
  }
  if(document.body)start();else document.addEventListener('DOMContentLoaded',start);
})();
